import React from 'react';
import { Link } from 'react-router-dom';
import { WINE_TYPES } from '../data/wines';
import { useWines } from '../context/WinesContext';
import { useT } from '../i18n/LanguageContext';
import { TYPE_KEYS, TYPE_DESC_KEYS } from '../i18n/translations';
import garrafaTinto from '../assets/garrafa_card_tinto.png';
import garrafaBranco from '../assets/garrafa_card_branco.png';

/* ============================================================
   VinhosOverlay — Overlay full-screen de categorias
   Mostra-se no hover do link "Vinhos" no Navbar.
   Ocupa toda a viewport com 1vw de padding, exceto a top nav
   que fica por cima. Scroll vertical se o conteúdo exceder.
   ============================================================ */

export default function VinhosOverlay({ open, onMouseEnter, onMouseLeave, onClose }) {
  const t = useT();
  const { wines } = useWines();
  return (
    <div
      className={`vinhos-overlay${open ? ' vinhos-overlay--open' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-hidden={!open}
    >
      <div className="vinhos-overlay__inner">

        <header className="vinhos-overlay__header">
          <p className="t-label" style={{ color: '#ffffff' }}>
            {t('overlay.eyebrow')}
          </p>
        </header>

        <div className="vinhos-overlay__grid">
          {WINE_TYPES.map(type => {
            const count = wines.filter(w => w.type === type).length;
            const samples = wines.filter(w => w.type === type).slice(0, 3);
            const typeLabel = TYPE_KEYS[type] ? t(TYPE_KEYS[type]) : type;
            const typeDesc  = TYPE_DESC_KEYS[type] ? t(TYPE_DESC_KEYS[type]) : '';

            // Foto real do produto (vinda da API) de um vinho deste tipo
            // exato — assim Reserva mostra a garrafa de Reserva, não uma
            // garrafa genérica. Só cai para a ilustração genérica se ainda
            // não existir nenhum vinho com foto para este tipo.
            const isBranco = type.includes('Branco');
            const garrafa = samples[0]?.image || (isBranco ? garrafaBranco : garrafaTinto);

            return (
              <Link
                key={type}
                to={`/loja?tipo=${encodeURIComponent(type)}`}
                className="vinhos-overlay__card"
                onClick={onClose}
              >
                <img
                  src={garrafa}
                  alt={typeLabel}
                  className="vinhos-overlay__card-img"
                />
                <p className="t-label vinhos-overlay__card-count" style={{ color: 'rgba(255,255,255,0.45)' }}>
                  {count} {count === 1 ? t('overlay.referenceSingular') : t('overlay.referencePlural')}
                </p>
                <h3 className="t-h4 vinhos-overlay__card-title" style={{ color: '#ffffff', marginTop: 'var(--sp-1)' }}>
                  {typeLabel}
                </h3>
                <p className="t-small vinhos-overlay__card-desc" style={{ color: 'rgba(255,255,255,0.5)', lineHeight: 1.5, marginTop: 'var(--sp-2)' }}>
                  {typeDesc}
                </p>
                <span className="vinhos-overlay__cta">
                  {t('overlay.viewInShop')} →
                </span>
              </Link>
            );
          })}
        </div>

        <footer className="vinhos-overlay__footer">
          <Link to="/loja" className="btn btn-lg btn--on-dark" onClick={onClose}>
            {t('overlay.viewAll')}
          </Link>
        </footer>

      </div>
    </div>
  );
}
